import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { isApiRequest } from './api-request';

export const tenantInterceptor: HttpInterceptorFn = (req, next) => {
  // Only the API's calls: the workspace is ours to name, and a header Zitadel
  // does not know would have its OIDC calls — the token refresh above all —
  // refused at the preflight.
  if (!isApiRequest(req)) return next(req);

  const router = inject(Router);

  let route = router.routerState.snapshot.root;
  let tenantId: string | null = null;

  while (route) {
    if (route.params['tenantId']) {
      tenantId = route.params['tenantId'];
      break;
    }
    if (!route.firstChild) break;
    route = route.firstChild;
  }

  if (!tenantId) return next(req);

  return next(req.clone({ setHeaders: { 'x-tenant-id': tenantId } }));
};
